import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-factory-menu',
  templateUrl: './factory-menu.component.html',
  styleUrls: ['./factory-menu.component.css']
})
export class FactoryMenuComponent implements OnInit {
    factoryId;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.factoryId = this.stateService.getStateParams()['factory_id'];
    }

    private async loadMenu() {
        if (!!this.factoryId) {
            this.menu = (await this.datatask.Post(2026, { factory_id: this.factoryId }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    factory_id: string;
    factory_name: string;
    company_name: string;
}
